//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@nuxtjs/composition-api";
import SfSidebar from "~/themes/fiskarsMoominDefault/components/components/organisms/SfSidebar/SfSidebar.vue";
import SfButton from "~/themes/fiskarsMoominDefault/components/components/atoms/SfButton/SfButton.vue";
import SfHeading from "~/themes/fiskarsMoominDefault/components/components/atoms/SfHeading/SfHeading.vue";
import SfFilter from "~/themes/fiskarsMoominDefault/components/components/molecules/SfFilter/SfFilter.vue";
import SfAccordion from "~/themes/fiskarsMoominDefault/components/components/organisms/SfAccordion/SfAccordion.vue";
import { useUiState } from "~/composables";
import SidebarLoader from "~/components/Sidebar/SidebarLoader";
import { getCMSLabels, showingOfProductsTitle } from '~/helpers/globalLabels';
import { useContext } from "@nuxtjs/composition-api"

export default defineComponent({
  name: "CategoryFilters",
  components: {
    SfSidebar,
    SfButton,
    SfHeading,
    SfFilter,
    SfAccordion,
    SidebarLoader,
  },
  props: {
    filtersLabel: {
      type: String,
    },
    filters: {
      type: Object,
      default: () => {},
    },
    selectedFilters: {
      type: Array,
      default: () => {},
    },
    totalCountFilteredProducts: {
      type: Number,
      default: 0
    },
    resultsShowing: {
      type: Number,
      default: 0
    },
  },
  methods: {
    extractValueByKey(key, extractKey) {
      /*0 : label : string
      1 : facetID : string
      2: isMoreFieldsAvailble : boolean
      */
      return extractKey == 2 ? JSON.parse(key.split(" | ")[extractKey]?.toLowerCase()) : key.split(" | ")[extractKey];
    },
    getAriaLabel(key) {
      const { i18n } = useContext();
      return i18n.t("buttons.filters.filter-by").replace("{0}", this.extractValueByKey(key, 0));
    },
  },
  setup(props, { emit }) {
    const { isFilterSidebarOpen, toggleFilterSidebar } = useUiState();

    const clearAllFilters = () => {
      emit("onClearAllFilters");
      toggleFilterSidebar();
    };

    const getShowMoreLabel = () => {
      return getCMSLabels('show-more');
    };

    const getApplyFiltersText = () => {
      return getCMSLabels('apply-filters') || 'Apply filters (hardcoded)';
    };
    const getClearAndCloseText = () => {
      return getCMSLabels('clear-filters') || 'Clear and close (hardcoded)';
    };

    return {
      isFilterSidebarOpen,
      toggleFilterSidebar,
      clearAllFilters,
      getShowMoreLabel,
      getApplyFiltersText,
      getClearAndCloseText,
      showingOfProductsTitle,
    };
  },
});
